import { CheckCircle2, Circle } from "lucide-react";
import { cn } from "@/lib/utils";
import { GCP_WIZARD_STEPS, type GcpWizardStepId } from "./wizard-state";

/** The six steps in order, with the current one marked. */
export function GcpWizardStepper({ current }: { current: GcpWizardStepId }) {
  const index = GCP_WIZARD_STEPS.findIndex((s) => s.id === current);
  return (
    <ol className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs" aria-label="Connect Google Cloud steps">
      {GCP_WIZARD_STEPS.map((step, i) => (
        <li
          key={step.id}
          aria-current={i === index ? "step" : undefined}
          className={cn("flex items-center gap-1", i === index ? "font-medium text-foreground" : "text-muted-foreground")}
        >
          {i < index ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" /> : <Circle className="h-3.5 w-3.5" />}
          <span>
            {i + 1}. {step.label}
          </span>
        </li>
      ))}
    </ol>
  );
}
